<template>
  <div
    :class="{ 'info-box': true, 'info-box--centered': isCentered, 'info-box--titleless': !title }"
  >
    <HdIcon :src="info" class="info-box__icon" />
    <template v-if="title">
      <HdToggle :open="isOpen" :title="title" @toggle="() => (isOpen = !isOpen)">
        <div class="info-box__text">
          <slot>
            <p v-html="text" />
          </slot>
        </div>
      </HdToggle>
    </template>
    <template v-else-if="!title">
      <div class="info-box__text">
        <slot>
          <p v-html="text" />
        </slot>
      </div>
    </template>
  </div>
</template>

<script>
import { info } from 'homeday-assets';
import { HdIcon, HdToggle } from 'homeday-blocks';

export default {
  name: 'InfoBox',
  components: { HdIcon, HdToggle },
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    isCentered: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      info,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.info-box {
  border: 1px getShade($quaternary-color, 50) solid;
  display: flex;
  padding: calc(#{$sp-m} + #{$sp-xs});

  ::v-deep &__icon {
    margin: $sp-xs calc(#{$sp-s} + #{$sp-xxs}) 0 $sp-xxs;
    width: 24px;

    > path {
      fill: getShade($secondary-color, 110);
    }
  }

  ::v-deep .hd-toggle {
    width: 100%;

    &--is-open .hd-toggle__body {
      max-height: fit-content !important;
    }

    &__control {
      @include font('DS-100');
      font-weight: 700;

      &-icon {
        width: 24px;
      }
    }
  }

  ::v-deep &__text,
  ::v-deep &__text p {
    @include font('DS-90');
  }

  &--centered {
    justify-content: center;
  }

  &--titleless {
    align-items: center;
  }

  &--titleless > &__icon {
    margin-top: 0;
  }

  &--titleless > &__text {
    @include font('DS-100');
  }
}
</style>
